// Configuração central do ClickDTF — altere aqui os valores comerciais.

// Largura útil (fixa) do filme DTF têxtil, em cm
export const DTF_PRINT_WIDTH = 28;

// Preço por metro linear de filme (R$). 1 metro linear = 28 cm x 100 cm
export const DTF_PRICE_PER_METER = 50;

// Espaçamento de segurança entre estampas (cm). 0 = sem margem
export const DTF_ART_SPACING = 0;

// Contato comercial
export const WHATSAPP_NUMBER = "5543988342026";
export const WHATSAPP_DISPLAY = "+55 43 98834-2026";

// Máximo de artes simultâneas na calculadora
export const DTF_MAX_ARTS = 3;

// Google AdSense (substitua pelo seu ID quando disponível)
export const ADSENSE_CLIENT = "ca-pub-0000000000000000";
export const ADSENSE_SLOTS = {
  top: "0000000001",
  afterCalculator: "0000000002",
  inArticle: "0000000003",
  preFooter: "0000000004",
};
